import { Box, DialogContentText, IconButton } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { FC, ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { DialogLayoutHr } from './dialog-layout-hr';
import DialogTitle from '@mui/material/DialogTitle';
import { StackLayout } from './stack-layout';

interface IProps extends DialogProps {
  header: ReactNode;
  showCloseButton?: boolean;
  onCloseIconClick?: () => void;
  bodyText?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  grayFooter?: boolean;
  open: boolean;
  noPadding?: boolean;
  noHeaderPaddingY?: boolean;
  scrollContents?: boolean;
  isSubControl?: boolean;
}

export const DialogLayout: FC<IProps> = ({
  header,
  showCloseButton,
  onCloseIconClick,
  bodyText,
  body,
  footer,
  open,
  children,
  grayFooter,
  noPadding,
  noHeaderPaddingY,
  scrollContents,
  isSubControl,

  ...otherProps
}) => {
  const formMethods = useForm();

  return (
    <div>
      <FormProvider {...formMethods}>
        <Dialog sx={{ height: '100%' }} open={open} {...otherProps}>
          <DialogTitle
            sx={{
              margin: '20px',
              overflow: 'hidden',
              paddingY: noHeaderPaddingY ? 0 : undefined,
              paddingX: noHeaderPaddingY ? 1 : undefined,
            }}
          >
            <StackLayout justifyContent="space-between">
              <Box sx={{ marginTop: isSubControl ? '0' : '20px' }}>
                {header}
              </Box>
              {showCloseButton && (
                <Box
                  sx={{
                    margin: isSubControl
                      ? '-40px 0px 0px 16px !important'
                      : '0',
                  }}
                >
                  <IconButton
                    aria-label="close"
                    onClick={onCloseIconClick}
                    size="small"
                  >
                    <CloseIcon
                      sx={{
                        marginBottom: '0',
                        width: '24px',
                        height: '24px',
                        marginTop: '10px',
                      }}
                    />
                  </IconButton>
                </Box>
              )}
            </StackLayout>
          </DialogTitle>
          <DialogLayoutHr />
          <DialogContent
            sx={{
              padding: noPadding ? 0 : undefined,
              margin: '0px 30px',
              overflow: scrollContents ? 'auto' : undefined,
            }}
          >
            {bodyText && (
              <DialogContentText marginBottom={2}>{bodyText}</DialogContentText>
            )}
            {body}
            {children}
          </DialogContent>
          {footer && (
            <>
              <DialogLayoutHr />
              <DialogActions
                sx={{
                  backgroundColor: grayFooter ? '#F6F6F6' : undefined,
                }}
              >
                {footer}
              </DialogActions>
            </>
          )}
        </Dialog>
      </FormProvider>
    </div>
  );
};
